import { http } from "@/api/config.js";
import qs from "qs";

//cookie
let cookieList = document.cookie ? document.cookie.split(";") : [];
let cookies = {};
cookieList.forEach((item) => {
  if (!cookies[item.split("=")[0].trim()])
    cookies[item.split("=")[0].trim()] = item.split("=")[1];
});

//查询(限制schoolID)
// ◦ idCon：编号（精确查询）
// ◦ nameCon：名称（模糊查询）
// ◦ startYearCon: 入学年份（4 位数字）（精确查询）
// ◦ periodCon：学制（数字）（精确查询）
// ◦ schoolIdCon：学校编号（模糊查询）
// ◦ createrCon：创建人（精确查询）
// ◦ createTimeQB：创建时间下限，格式：YYYY-MM-DD hh:mm:ss
// ◦ createTimeQE：创建时间上限，格式：YYYY-MM-DD hh:mm:ss
// ◦ idsCon：编号集合（数组格式）
// lower和upper
export const QueriesApi = (data, schoolId) => {
  for (let key in data) {
    if (data[key] === "") {
      delete data[key];
    }
  }
  data.schoolIdCon = schoolId;

  return http({
    url: `/users/queries`,
    method: "POST",
    data: qs.stringify(data, { arrayFormat: "repeat" }),
  });
};

//数量查询
export const CountQueriesApi = (data, schoolId) => {
  for (let key in data) {
    if (data[key] === "") {
      delete data[key];
    }
  }
  data.schoolIdCon = schoolId;

  return http({
    url: `/users/count-queries`,
    method: "POST",
    data: qs.stringify(data, { arrayFormat: "repeat" }),
  });
};

//修改(编号，修改信息)
// ▪ name：名称
// ▪ tel: 电话
// ▪ email：邮箱
// ▪ realGrade：真实年级
// ▪ realClass：真实班级
// ▪ batchId：批次编号
// ▪ specialty：专业
// ▪ role：角色
export const UsersUpdateApi = (data) => {
  data.idCon = cookies["user-idcon"];
  data.lower = 0;
  data.upper = 1;
  return http({
    url: `/users/update`,
    method: "POST",
    data: qs.stringify(data, { arrayFormat: "repeat" }),
  });
};
//查询用户
export const GetUsersByIdApi = (id) => {
  return http.get(`/users/${id}`);
};

//查询班级
export const GetClassByIdApi = (id) => {
  return http.get(`/classes/${id}`);
};
export const GetClassByCodeApi = (code) => {
  let data = {
    lower: 0,
    upper: 1,
    codeCon: code,
  };
  return http.post(
    `/classes/queries?${qs.stringify(data, { arrayFormat: "repeat" })}`
  );
};

//添加学生
export const AddUserApi = (data) => {
  return http({
    url: `/classes/users/add`,
    method: "POST",
    data: qs.stringify(data, { arrayFormat: "repeat" }),
  });
};
